var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLink = function SvgIconLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon_link_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_link_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5E6574",
    d: "M6 14c-1.107 0-2.05-.39-2.83-1.171C2.39 12.048 2 11.103 2 9.995s.39-2.05 1.17-2.828C3.95 6.389 4.893 6 6 6h2.25c.213 0 .39.071.534.214A.72.72 0 0 1 9 6.746c0 .21-.072.39-.216.535a.72.72 0 0 1-.534.219H6a2.41 2.41 0 0 0-1.77.73A2.41 2.41 0 0 0 3.5 10c0 .694.243 1.285.73 1.77.485.487 1.076.73 1.77.73h2.25c.213 0 .39.072.534.214a.72.72 0 0 1 .216.532c0 .21-.072.39-.216.535A.72.72 0 0 1 8.25 14H6Zm1.756-3.25a.738.738 0 0 1-.537-.214.714.714 0 0 1-.219-.532c0-.21.072-.39.215-.535a.72.72 0 0 1 .534-.219h4.495c.212 0 .391.071.537.214.146.143.219.32.219.532 0 .21-.072.39-.215.535a.719.719 0 0 1-.534.219H7.756ZM11.75 14a.728.728 0 0 1-.534-.214.72.72 0 0 1-.216-.532c0-.21.072-.39.216-.535a.72.72 0 0 1 .534-.219H14c.694 0 1.285-.243 1.77-.73.487-.485.73-1.076.73-1.77s-.243-1.285-.73-1.77A2.41 2.41 0 0 0 14 7.5h-2.25a.728.728 0 0 1-.534-.214.72.72 0 0 1-.216-.532c0-.21.072-.39.216-.535A.72.72 0 0 1 11.75 6H14c1.107 0 2.05.39 2.83 1.171.78.781 1.17 1.726 1.17 2.834s-.39 2.05-1.17 2.828C16.05 13.611 15.107 14 14 14h-2.25Z"
  }))));
};
export default SvgIconLink;